import API from "@/services/api";
import { 
  ChangeVBPercentageAPIParams,
  FetchVBPercentagesAPIResponse
} from "../types/virtualBattery";

export enum EndpointName {
  FetchPercentages = '/contract/bateria_virtual_percentages/:bateriaId',
  ChangePercentage = '/contract/:contractName/change_bateria_pes_percentatge/:bateriaId',
}

const fetchPercentages = (bateriaId: number) => {
  return API.get<FetchVBPercentagesAPIResponse>({
    endpoint: EndpointName.FetchPercentages,
    versions: [2],
    params: {
      bateriaId
    }
  });
}

const changePercentage = (
  contractName: string, 
  bateriaId: number,
  percentatge: number
) => {
  return API.put<void, ChangeVBPercentageAPIParams>({
    endpoint: EndpointName.ChangePercentage,
    versions: [2],
    data: { pes_percentatge: percentatge },
    params: {
      contractName,
      bateriaId
    }
  });
}

export default {
  changePercentage,
  fetchPercentages
};